import { render, staticRenderFns } from "./Distribute.vue?vue&type=template&id=a7fd810a&scoped=true"
import script from "./Distribute.vue?vue&type=script&lang=js"
export * from "./Distribute.vue?vue&type=script&lang=js"
import style0 from "./Distribute.vue?vue&type=style&index=0&id=a7fd810a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd810a",
  null
  
)

export default component.exports